import { render, staticRenderFns } from "./mediaLibrary.vue?vue&type=template&id=b7615c5a&scoped=true"
import script from "./mediaLibrary.vue?vue&type=script&lang=js"
export * from "./mediaLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7615c5a",
  null
  
)

export default component.exports